import { ICardsReducer } from 'utils/types';
import { cardsInitialState } from './reducer';

export const resetCardsReducerOperation = (): ICardsReducer => {
	return { ...cardsInitialState };
};
